export default __webpack_public_path__ + "static/media/venus.18616bea.png";